export default __webpack_public_path__ + "static/tech_hub_logo-e11f63f87fa007732b73393f03268774.svg";